import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { camps } from '~/data/camps';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/camps/$campSlug')({
  component: CampDetail,
  loader: ({ params }) => {
    const camp = camps.find(c => c.slug === params.campSlug);
    if (!camp) {
      throw new Error('Camp not found');
    }
    return { camp };
  },
});

function CampDetail() {
  const { camp } = Route.useLoaderData();
  const locale = useStore(langStore, s => s);

  return (
    <div>
      <h1 className="mb-4 text-3xl font-bold text-black">{camp.title[locale]}</h1>
      <MarkdownBlock
        renderers={{
          p: ({ node, ...props }) => <p className="mb-2 text-left" {...props}></p>,
        }}
      >
        {String(camp.description[locale])}
      </MarkdownBlock>
    </div>
  );
}
